import { render, staticRenderFns } from "./P03BankAccount.vue?vue&type=template&id=653b326b&scoped=true&lang=pug"
import script from "./P03BankAccount.vue?vue&type=script&lang=js"
export * from "./P03BankAccount.vue?vue&type=script&lang=js"
import style0 from "./P03BankAccount.vue?vue&type=style&index=0&id=653b326b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653b326b",
  null
  
)

export default component.exports